import { BodyAlert } from "./BodyAlert";
export default BodyAlert;
